import { OktonSimpleCrudList } from '@okton/platform-ui';
import { Compass } from 'lucide-react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import BankAppPage from '../../layout/BankAppPage';
import {
  useDeleteDirecionador,
  useDirecionadores,
} from '../../services/hooks/useCadastros';

const Direcionadores = () => {
  const history = useHistory();
  const {
    data: direcionadores = [],
    isLoading,
    isError,
    refetch,
  } = useDirecionadores();
  const deleteMutation = useDeleteDirecionador();

  return (
    <BankAppPage>
      <>
        <OktonSimpleCrudList
          horizontalSpacing={0}
          title="Direcionadores"
          description="Orientador de Operação usado na classificação dos lançamentos"
          newLabel="Novo Direcionador"
          onNew={() => history.push('/direcionadores/novo')}
          onEdit={id => history.push(`/direcionadores/${id}`)}
          icon={Compass}
          emptyMessage="Nenhum direcionador cadastrado"
          detailColumnTitle="Plano de Contas (DFC)"
          items={direcionadores.map(d => ({
            id: d.id_ori,
            name: d.nome_ori,
            detail: d.nome_pct
              ? `${d.item_pct ?? ''} ${d.nome_pct}`.trim()
              : undefined,
          }))}
          loading={isLoading}
          error={isError}
          onRetry={refetch}
          onDelete={id => deleteMutation.mutateAsync(id)}
          deleteConfirmation="Excluir este Direcionador do IFLEX?"
        />
      </>
    </BankAppPage>
  );
};

export default Direcionadores;
